// Explore-stats page: Longest serving members (over 20 years).
// Recreates the Handbook page — mean/mode service stat cards, chamber and
// gender filters, and a table of everyone who served more than 20 years.

import React, { useState, useEffect } from 'react';
import {
  Paper, Grid, Typography, Box, ToggleButton, ToggleButtonGroup,
} from '@mui/material';
import { getExploreStat } from '../../services/api';
import ExploreStatsPage from './ExploreStatsPage';

export default function LongestServingMembers() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [chamber, setChamber] = useState('all');
  const [gender, setGender] = useState('all');

  useEffect(() => {
    let active = true;
    setLoading(true);
    (async () => {
      try {
        const params = {};
        if (chamber !== 'all') params.chamber = chamber;
        if (gender !== 'all') params.gender = gender;
        const res = await getExploreStat('longest-serving-members', params);
        if (active) { setData(res); setError(null); }
      } catch (e) {
        if (active) setError(e.message || 'Failed to load statistics');
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, [chamber, gender]);

  const cards = data?.charts?.stat_cards || [];

  return (
    <ExploreStatsPage
      title="Longest serving members (over 20 years)"
      description={`Parliamentarians who have served in Parliament for more than 20 years${
        data?.charts?.total ? ` (${data.charts.total})` : ''
      }, with the mean and mode years of service.`}
      loading={loading}
      error={error}
      columns={data?.columns || []}
      rows={data?.table_rows || []}
      links={data?._links || []}
      csvName="longest-serving-members"
    >
      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 2 }}>
        <ToggleButtonGroup size="small" exclusive value={chamber}
                           onChange={(e, v) => v && setChamber(v)}>
          <ToggleButton value="all">All</ToggleButton>
          <ToggleButton value="members">Members</ToggleButton>
          <ToggleButton value="senators">Senators</ToggleButton>
        </ToggleButtonGroup>
        <ToggleButtonGroup size="small" exclusive value={gender}
                           onChange={(e, v) => v && setGender(v)}>
          <ToggleButton value="all">Everyone</ToggleButton>
          <ToggleButton value="women">Women</ToggleButton>
          <ToggleButton value="men">Men</ToggleButton>
        </ToggleButtonGroup>
      </Box>

      {data && (
        <Grid container spacing={2} sx={{ mb: 3 }}>
          {cards.map((c) => (
            <Grid item xs={6} key={c.label}>
              <Paper elevation={1} sx={{ p: 2, borderRadius: 3, textAlign: 'center' }}>
                <Typography variant="h3" color="primary">{c.value}</Typography>
                <Typography variant="body2" color="text.secondary">{c.label}</Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      )}
    </ExploreStatsPage>
  );
}
